// frontend/components/common/MaskedSecret.tsx

"use client";

import { useState } from "react";
import { Copy, Check } from "lucide-react";
import { copyToClipboard } from "../../utils/clipboard";

interface MaskedSecretProps {
  value: string;
  className?: string;
}

// 임시 비밀번호 등 민감한 값을 화면에 평문으로 노출하지 않고,
// 클릭 시 클립보드로 복사만 되도록 표시합니다.
export default function MaskedSecret({ value, className = "" }: MaskedSecretProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    const ok = await copyToClipboard(value);
    if (ok) {
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    }
  };

  return (
    <button
      type="button"
      onClick={handleCopy}
      title="클릭하여 복사"
      className={`inline-flex items-center gap-1 font-mono font-bold bg-white dark:bg-black/40 px-1.5 py-0.5 rounded border dark:border-zinc-800 cursor-pointer hover:opacity-80 transition-opacity select-none ${className}`}
    >
      <span aria-hidden="true">{"•".repeat(Math.min(value.length, 10) || 8)}</span>
      {copied ? <Check size={12} className="text-green-500" /> : <Copy size={12} />}
      <span className="sr-only">{copied ? "복사됨" : "클릭하여 복사"}</span>
    </button>
  );
}
